import { render, staticRenderFns } from "./FutureProfessionsGrid.vue?vue&type=template&id=00d2a5c6&scoped=true"
import script from "./FutureProfessionsGrid.vue?vue&type=script&lang=ts"
export * from "./FutureProfessionsGrid.vue?vue&type=script&lang=ts"
import style0 from "./FutureProfessionsGrid.vue?vue&type=style&index=0&id=00d2a5c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d2a5c6",
  null
  
)

export default component.exports